export default "__VITE_ASSET__6ef0de1d__"